export class TokenDTO {
  accessToken: string;

  refreshToken: string;

  email: string;
}
